/* eslint-disable jsx-a11y/anchor-is-valid, no-script-url */
import React from 'react';
import PropTypes from 'prop-types';
import { FeedSelectorView } from './feed-selector';
import { FeedAttributeSelectorView } from './feed-attribute-selector';
import { DefaultTextEditorView } from './default-text-editor';
import { FeedSyntaxView } from './feed-syntax';

export class FeedAndAttributeSelectorView extends React.Component {
  static defaultProps = {
    feeds: [],
    selectedFeed: null,
    selectedAttribute: null,
    canIgnoreDefaultText: true,
    defaultText: '',
    showSyntax: true,
    maxLength: 0,
  };

  constructor(props) {
    super(props);

    this.state = {
      selectedFeed: this.props.selectedFeed,
      selectedAttribute: this.props.selectedAttribute,
      defaultText: this.props.defaultText,
      maxLength: this.props.maxLength,
      prevProps: this.props,
    };
  }

  // update state when props update
  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps !== prevState.prevProps) {
      return {
        selectedFeed: nextProps.selectedFeed,
        selectedAttribute: nextProps.selectedAttribute,
        defaultText: nextProps.defaultText,
        maxLength: nextProps.maxLength,
        prevProps: nextProps,
      };
    }
    return null;
  }

  onFeedSelected = (selectedFeed, _index, event) => {
    if (!selectedFeed.noNextLevel) {
      this.setState({
        selectedFeed,
      });
    }
    const { onUserSelectionUpdated } = this.props;
    onUserSelectionUpdated({
      Id: selectedFeed.Id,
      selectedFeedName: selectedFeed.Name,
      selectedAttributeName: '',
    }, event);
  };

  onDefaultTextInputDone = (defaultText, event) => {
    const { onUserActionCompleted } = this.props;

    onUserActionCompleted({
      Id: this.state.selectedFeed.Id,
      selectedFeedName: this.state.selectedFeed.Name,
      selectedAttributeName: this.state.selectedAttribute,
      defaultText,
    }, event);
  };

  onFeedAttributeSelected = (selectedAttribute, _index, event) => {
    this.setState({
      selectedAttribute,
    });

    const { onUserSelectionUpdated } = this.props;
    onUserSelectionUpdated({
      Id: this.state.selectedFeed.Id,
      selectedFeedName: this.state.selectedFeed.Name,
      selectedAttributeName: selectedAttribute,
    }, event);
  };

  renderSelectorView() {
    const {
      i18n, feeds, canIgnoreDefaultText,
    } = this.props;
    if (this.state.selectedFeed && this.state.selectedAttribute) {
      return (
        <DefaultTextEditorView
          i18n={i18n}
          maxLength={this.state.maxLength}
          onSaveOrOnCancel={this.onDefaultTextInputDone}
          enableCancel={canIgnoreDefaultText}
          defaultText={this.state.defaultText}
        />
      );
    }

    if (this.state.selectedFeed && !this.state.selectedAttribute) {
      return (
        <FeedAttributeSelectorView
          attributeNames={this.state.selectedFeed.AttributeNames}
          i18n={i18n}
          onSelect={this.onFeedAttributeSelected}
        />
      );
    }

    return (
      <FeedSelectorView
        feeds={feeds}
        i18n={i18n}
        onSelect={this.onFeedSelected}
      />
    );
  }

  render() {
    const { showSyntax, i18n } = this.props;
    const selectorView = this.renderSelectorView();
    const { selectedFeed, selectedAttribute } = this.state;
    const syntaxView = showSyntax ? (<FeedSyntaxView
      selectedAttribute={!!selectedAttribute}
      selectedFeed={!!selectedFeed}
      i18n={i18n}
    />) : null;
    return (
      <div className="feed-and-attribute-selector panel margin-zero padding-zero">
        {syntaxView}
        <div className="panel-body padding-zero">
          {selectorView}
        </div>
      </div>
    );
  }
}

FeedAndAttributeSelectorView.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
  feeds: PropTypes.arrayOf(PropTypes.shape({
    Name: PropTypes.string,
    AttributeNames: PropTypes.arrayOf(PropTypes.string),
    Id: PropTypes.number,
  })),
  selectedFeed: PropTypes.shape({
    Name: PropTypes.string,
    AttributeNames: PropTypes.arrayOf(PropTypes.string),
    Id: PropTypes.number,
  }),
  maxLength: PropTypes.number,
  selectedAttribute: PropTypes.string,
  defaultText: PropTypes.string,
  onUserSelectionUpdated: PropTypes.func.isRequired,
  onUserActionCompleted: PropTypes.func.isRequired,
  canIgnoreDefaultText: PropTypes.bool,
  showSyntax: PropTypes.bool,
};
